<template>
	<div class="sub-values inline">
		<div class="sub-value">
			<div class="label">
				<template v-if="data.type === 'immediately'">Ab sofort</template>
				<template v-else-if="data.type === 'date'">Ab {{ data.date | dateByObject }}</template>
				<template v-else-if="data.type === 'notice-period'">
					Nach {{ data.noticePeriod }} Monat(en) Kündigungsfrist
				</template>
			</div>
		</div>
	</div>
</template>

<script>

export default {

	props: {
		data: {
			type: Object,
			required: false,
		},
	},
}
</script>
